module.exports = __webpack_public_path__ + "static/media/FacistBoard_large_6.07bd8e7a.png";